var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAutumnNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maple-leaf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#f5af29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.55,398.36V338.48s5.14-8.24,7.42-7.19l70.39,32.22s-11.91-33.47-13.92-38.6-3-11.6,2.56-15.53c5.85-4.11,63.65-48.72,63.65-48.72s-10.55-4.55-13.47-5.94c-4.31-2.05-3.42-6.83-2.89-8.62s12.08-40.55,12.08-40.55S355.82,212.3,350,213.3c-5,.89-5.92-1.33-6.64-2.79-1.4-2.84-8.22-18.29-8.22-18.29s-24.89,28.41-30.64,34.65c-4.63,5.05-10.43,1.21-9.23-4.67,1.15-5.54,15.38-72.65,15.38-72.65s-16.64,9.09-21.34,12.24-7.25,1.45-8.84-1.54S256,113.64,256,113.64s-23,43.62-24.52,46.61-4.16,4.69-8.84,1.54-21.34-12.24-21.34-12.24,14.24,67.1,15.39,72.65c1.18,5.89-4.6,9.73-9.24,4.67-5.76-6.24-30.63-34.65-30.63-34.65s-6.82,15.45-8.22,18.29c-.72,1.46-1.59,3.68-6.65,2.79-5.77-1-36.3-7.73-36.3-7.73s11.51,38.77,12.06,40.55,1.43,6.56-2.88,8.62c-2.92,1.4-13.46,5.94-13.46,5.94s57.78,44.6,63.64,48.72c5.58,3.93,4.55,10.37,2.55,15.53s-13.92,38.6-13.92,38.6,68.12-31.18,70.39-32.22,7.42,7.19,7.42,7.19v59.88",
    fill: "#ec582d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutumnNew);
export default __webpack_public_path__ + "static/media/autumn-new.5d9d84a37e7812f1292e6dc4a8c4e4e7.svg";
export { ForwardRef as ReactComponent };